import { Base } from './base.js';

export class Social extends Base {
    constructor() {
        super();
        this.socialLoginMessage = document.querySelector('.socialloginmsg');
        
        this.emailInput = document.getElementById('emailInput');
        this.passwordInput = document.getElementById('passwordInput');

        this.postcodeInput = document.getElementById('postcodeInput');
        this.postcodeError = document.querySelector('.form-error-postcode');

        this.passwordCheckButton = document.getElementById('checkLoginButton');
        this.confirmButton = document.querySelector('.check-login-button');
        this.agbConfirm = document.getElementById('agbInput');
        this.commentsConfirm = document.getElementById('commentsInput');
        this.confirmError = document.getElementById('missingAgb');
    }

    googleLogin() {
        let ref = CONFIG.redirectUrl 
        let reason = CONFIG.registrationReason 
        
        //Google extended access?
        let sentParams = this.getUrlParams();
        let context = ("context" in sentParams) ? sentParams.context : "";
        let activation = ("activation" in sentParams) ? sentParams.activation : "";
        let socialType = CONFIG.environment.socialType != "" ? CONFIG.environment.socialType : "google";

        this.hideErrorMessages();
        
        let formData = {
            referer: ref,
            reason: reason,
            socialType : socialType,
            context: context,
            activation: activation,
        };



        // console.log("Google Login Form Data: ", formData);
        
        let request = new Request('POST', '/api/get/socialloginurl');

        request.data = formData;
        request.call(response => {
            if (response.status == 'ok') {
                console.log("Google Login URL: ", response.data.url);
                window.location.href = response.data.url;
            } else {
                if (this.socialLoginMessage) {
                    this.socialLoginMessage.innerHTML = "Bei der Verbindung zum Login bei Google ist ein Fehler aufgetreten. Die korrekte URL konnte nicht ermittelt werden. Bitte versuchen Sie es erneut oder wenden Sie sich an unseren Leserservice.";
                    this.showBlock('.socialloginmsg');
                }
            }
        }, () => {
            if (this.socialLoginMessage) {
                this.socialLoginMessage.innerHTML = this.errorCode.unknownError;
                this.showBlock('.socialloginmsg');
            }
        });
    }

    appleLogin() {
        this.buttonSpinner(".apple-button");
        let ref = CONFIG.redirectUrl
        let reason = CONFIG.registrationReason
        let socialType = "apple";
        let sentParams = this.getUrlParams();
        let context = ("context" in sentParams) ? sentParams.context : "";
        let activation = ("activation" in sentParams) ? sentParams.activation : "";
        this.hideErrorMessages();
        
        let formData = {
            referer: ref,
            reason: reason,
            socialType: socialType,
            context: context,
            activation: activation,
        };
        let request = new Request('POST', '/api/get/socialloginurl');

        request.data = formData;
        request.call(response => {
            if (response.status == 'ok') {
                this.buttonSpinner(".apple-button", false);
                window.location.href = response.data.url;

            } else {

                if (this.socialLoginMessage) {
                    this.socialLoginMessage.innerHTML = "Bei der Verbindung zum Login bei Apple ist ein Fehler aufgetreten. Die korrekte URL konnte nicht ermittelt werden. Bitte versuchen Sie es erneut oder wenden Sie sich an unseren Leserservice.";
                    this.showBlock('.socialloginmsg');
                    console.log("Error: ", response);
                }
                this.buttonSpinner(".apple-button", false);
            }
        }, () => {
            if (this.socialLoginMessage) {
                this.socialLoginMessage.innerHTML = this.errorCode.unknownError;
                this.showBlock('.socialloginmsg');
                this.buttonSpinner(".apple-button", false);
            }
        });
    }

    googleExternalLink() {
        this.pushHistoryState("googleExternalLink");
    }
    appleExternalLink() {
        this.pushHistoryState("appleExternalLink");
    }

    login() {
        this.pushHistoryState("socialLogin");
    }

    errorGpMissing(message) {
        let element = document.querySelector('.form-error-customerId > p.error');
        if (element) {
            element.innerHTML = message;
            this.showBlock('.form-error-customerId');
        }
    }

    loginConfirm() {
        this.pushHistoryState("socialLoginConfirm");

        if (CONFIG.socialLoginGoogleParams.postcodeMissing == true) {
            this.showBlock('#postcodeBlock');
        }

        if (this.emailInput) {
            this.emailInput.addEventListener('change', () => {
                this.hideErrorMessages();
            });
        }

        if (this.passwordInput) {
            this.passwordInput.addEventListener('change', () => {
                this.hideErrorMessages();
            });
        }

        
        if (this.postcodeInput) {
            this.postcodeInput.addEventListener('change', () => {
                this.hideErrorMessages();
            });
        }

        if (this.passwordCheckButton) {
            this.passwordCheckButton.addEventListener('click', (event) => {
                event.preventDefault();
                this.socialLoginConfirm();
            });
        }
    }

    loginConsensConfirm() {
        this.pushHistoryState("socialLoginConsensConfirm");

        if (this.agbConfirm) {
            this.agbConfirm.addEventListener('change', () => {
                this.hideErrorMessages();
            });
        }

        if (this.commentsConfirm) {
            this.commentsConfirm.addEventListener('change', () => {
                this.hideErrorMessages();
            });
        }

        if (this.postcodeInput) {
            this.postcodeInput.addEventListener('change', () => {
                this.hideErrorMessages();
            });
        }
        
        if (this.confirmButton) {
            this.confirmButton.addEventListener('click', (event) => {
                event.preventDefault();
                this.socialConsens();
            });
        }
    }

    socialLoginConfirm() {
        if (!this.emailInput.value) {
            console.log("E-Mail nicht übermittelt oder Reload der Seite erfolgt. Leite zum Start zurück.");
            window.location.href = this.baseUrl + "/" + window.location.search;
        } else {
            this.emailInput.addEventListener("focus", () => {
                this.hideErrorMessages();
            });
        }

        if (this.passwordInput) {
            this.passwordInput.addEventListener("focus", () => {
                this.hideErrorMessages();
            });
        }

        if (this.postcodeInput) {
            this.postcodeInput.addEventListener("focus", () => {
                this.hideErrorMessages();
            });
        }

        let postcodeValue = "";

        if (CONFIG.socialLoginGoogleParams.postcodeMissing == true) {
            if (this.postcodeInput.value == "") {
                this.postcodeError.innerHTML = "Das Feld Postleitzahl darf nicht leer sein. Bitte geben Sie Ihre Postleitzahl ein.";
                this.showBlock('.form-error-postcode');
                this.buttonSpinner(".check-login-button", false);
                return;
            } else if(!/^\d{5}$/.test(this.postcodeInput.value)) {
                this.postcodeError.innerHTML = "Die Postleitzahl muss aus genau 5 Ziffern bestehen und darf nur Zahlen enthalten.";
                this.showBlock('.form-error-postcode');
                this.buttonSpinner(".check-login-button", false);
                return;
            } else {
                postcodeValue = this.postcodeInput.value;
            }
        }

        this.buttonSpinner(this.passwordCheckButton);
        if(this.passwordInput.value != "") {
            this.hideErrorMessages();
                    
            let sentParams = this.getUrlParams();
            let sType = ("socialType" in sentParams) ? sentParams.socialType : "google";
            // get Snowplow cookies
            let spnozmhn_spId = this.findCookieName("nozmhn_spid");
            let conversion_Id = CONFIG.registrationReason == "Paywall" ? Cookies.get("_pc_conversion_id", false) : false;
            let formData = {
                form: 'socialProfileMergeConfirm',
                password: this.passwordInput.value,
                email: this.emailInput.value,
                linkingState: CONFIG.socialLoginGoogleParams.linkingState ? CONFIG.socialLoginGoogleParams.linkingState : '',
                referrer: this.redirectUrl,
                socialType: sType,
                spnozmhnIdName: spnozmhn_spId,
                spnozmhnIdValue: Cookies.get(spnozmhn_spId, false),
                sp: Cookies.get("sp", false),
                remoteIp: CONFIG.client.ip,
                userAgent: CONFIG.client.userAgent,
                conversionId: conversion_Id,
            };
            if (postcodeValue != "") {
                formData.postcode = postcodeValue;
            }
            
            let request = new Request('POST', '/api/confirm/sociallogin');
            request.data = formData;
            request.call(response => {
                if (response.status == 'ok') {
                    if (response.data.accessToken) {
                        if (CONFIG.environment.isLocal) {
                            this.redirectUrl = this.redirectUrl + "&globalSessionId=" + response.data.accessToken;
                        }

                        let redirect = false;
                        if (response.data.tac) {
                            this.tacCookie = response.data.tac;
                            redirect = this.redirectUrl;
                        }
    
                        this.utpCookie = response.data.accessToken;
    
                        if (this.missingName) {
                            document.location.href = this.missingNameRoute;
                        } else {
                            if (redirect) {
                                if(Cookies.get("_pc_conversion_id", false)) {
                                    Cookies.remove("_pc_conversion_id", false);
                                }
                                if(!CONFIG.environment.isAudioApp) {
                                    document.location.href = redirect;    
                                } else {
                                    document.location.href = "audioapp-shz://open_app?access_token=" + this.utpCookie;
                                }
                            } else {
                                this.updateTacCookie();
                            }
                        }
                    } else {
                        this.buttonSpinner(".check-login-button", false);
                    }
                } else {
                    let message = "Bei der Überprüfung Ihres Passwortes ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.";
                    if (response.code == 403) {
                        message = "Das eingegebene Passwort ist nicht korrekt. Bitte versuchen Sie es erneut.";
                    }
                    console.error("Error: ", response);
                    document.querySelector('.form-error-password').innerHTML = message;
                    this.showBlock('.form-error-password');
                    this.buttonSpinner(".check-login-button", false);
                }
            }, () => {
                this.buttonSpinner(".check-login-button", false);
            });
        }
    }

    socialConsens() {
        this.buttonSpinner(".check-login-button");

        if(CONFIG.environment.context == "gp" && document.querySelector('#customerIdInput') == "") {
            this.errorGpMissing("Das Feld Kundennummer darf nicht leer sein. Bitte geben Sie Ihre Kundennummer ein.");
            this.buttonSpinner(".check-login-button", false);
            return;
        }
    
        if( (! this.agbConfirm.checked) || (! this.commentsConfirm.checked) ) {
            this.showBlock(this.confirmError);
            this.confirmError.innerHTML = "Bitte bestätigen Sie die Allgemeinen Geschäftsbedingungen, die Widerufsbelehrung und die Richtlinien für Kommentare, um fortzufahren.";
            this.buttonSpinner(".check-login-button", false);
        } else if (this.postcodeInput.value == "") {
            this.postcodeError.innerHTML = "Das Feld Postleitzahl darf nicht leer sein. Bitte geben Sie Ihre Postleitzahl ein.";
            this.showBlock('.form-error-postcode');
            this.buttonSpinner(".check-login-button", false);
            return;
        } else if(!/^\d{5}$/.test(this.postcodeInput.value)) {
            this.postcodeError.innerHTML = "Die Postleitzahl muss aus genau 5 Ziffern bestehen und darf nur Zahlen enthalten.";
            this.showBlock('.form-error-postcode');
            this.buttonSpinner(".check-login-button", false);
            return;
        } else {
            this.hideErrorMessages();

            let sentParams = this.getUrlParams();
            let sType = ("socialType" in sentParams) ? sentParams.socialType : "google";
            let spnozmhn_spId = this.findCookieName("nozmhn_spid");
            let conversion_Id = CONFIG.registrationReason == "Paywall" ? Cookies.get("_pc_conversion_id", false) : false;

            let formData = {
                form: 'formConsensConfirm',
                additionalInputState: CONFIG.socialLoginGoogleParams.additionalInputState ? CONFIG.socialLoginGoogleParams.additionalInputState : '',
                regReason: CONFIG.registrationReason,
                referrer: this.redirectUrl,
                socialType: sType,
                spnozmhnIdName: spnozmhn_spId,
                spnozmhnIdValue: Cookies.get(spnozmhn_spId, false),
                sp: Cookies.get("sp", false),
                gtmPreview: Cookies.get("X-Gtm-Server-Preview", false),
                remoteIp: CONFIG.client.ip,
                userAgent: CONFIG.client.userAgent,
                conversionId: conversion_Id,
                activation: CONFIG.environment.activation,
                postcode: this.postcodeInput.value,
            };

            let request = new Request('POST', '/api/confirm/socialConsens');
            request.data = formData;
            request.call(response => {
                if (response.status == 'ok') {
                    if (response.data.accessToken) {
                        if (CONFIG.environment.isLocal) {
                            this.redirectUrl = redirectUrl + "&globalSessionId=" + response.data.accessToken;
                        }

                        let redirect = false;
                        if (response.data.tac) {
                            this.tacCookie = response.data.tac;
                            redirect = this.redirectUrl;
                        }

                        this.utpCookie = response.data.accessToken;

                        if (this.missingName) {
                            document.location.href= this.missingNameRoute;
                        } else {
                            if (redirect) {
                                if(Cookies.get("_pc_conversion_id", false)) {
                                    Cookies.remove("_pc_conversion_id", false);
                                }
                                if(!CONFIG.environment.isAudioApp) {

                                    if(CONFIG.environment.context == "gp") {

                                        // context is gp => check GP
                                        
                                        console.log("Enrich Customer ID after check...");
                                        this.passwordCheckButton.classList.add('d-none');
                                        document.getElementById('checkCustomerIdButton').classList.remove('d-none');
                                        this.buttonSpinner('.check-customerid-button');
                                        document.querySelector('.optin-block').classList.add('d-none');
                                        
                                        let customerIdInputField = document.querySelector('#customerIdInput');
                                        let checkCustomerIdButton = document.querySelector('#checkCustomerIdButton');
                                        let lastName = "";
                                        const payload = this.parseJwt(this.utpCookie);
                                        
                                        if (payload && payload.email) {
                                             this.emailInput.value = payload.email;
                                        } else {
                                             // error handling if email can not be found in token
                                            console.error("Email not found in JWT token.");
                                            this.errorGpMissing("Token nicht gültig, E-Mail konnte im Token nicht gefunden werden.");
                                            this.buttonSpinner('.check-customerid-button', false);
                                            return;
                                        }
                                        if (payload && payload.family_name) {
                                            lastName = payload.family_name;
                                        } else {
                                            // info last name is not in token
                                            lastName = "";
                                        }

                                        checkCustomerIdButton.addEventListener('click', async (event) => {
                                            event.preventDefault();
                                            this.hideErrorMessages();
                                            this.buttonSpinner('.check-customerid-button');
                                            if (customerIdInputField.value != "") {
                                                this.hideBlock("#customerIdBlock");
                                                this.showBlock("#checkDataBlock");
                                                let result = await this.validateDecryptedGp(customerIdInputField.value, lastName);
                                                if (typeof result.status != 'undefined' && result.status == "ok") {
                                                        console.log("Customer ID is valid: " + customerIdInputField.value);
                                                        this.enrichCustomerId(redirect, false);
                                                } else {
                                                        console.log("Error checking GP: ", result);
                                                        this.hideBlock("#checkDataBlock");
                                                        this.showBlock("#customerIdBlock");
                                                        this.errorGpMissing(this.errorCode.getByCode(this.decryptedCustomerId.value));
                                                        this.buttonSpinner('.check-customerid-button', false);
                                                        return;
                                                }
                                            } else {
                                                this.errorGpMissing(this.errorCode.gpMissingError);
                                                this.buttonSpinner('.check-customerid-button', false);
                                            }
                                        });
                                        checkCustomerIdButton.click();
                                    } else {
                                        // Normal case => redirect to redirectUrl
                                        document.location.href = redirect;
                                    }
                                    
                                } else {
                                    document.location.href = "audioapp-shz://open_app?access_token=" + this.utpCookie;
                                }
                            } else {
                                this.updateTacCookie();
                            }
                        }
                    } else {
                        this.buttonSpinner(".check-login-button", false);
                    }
                } else {
                    console.error("Error: ", response);
                    document.querySelector('.form-error-confirm').innerHTML = "Bei der Einrichtung Ihres Kontos ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.";
                    this.showBlock('.form-error-confirm');
                    this.buttonSpinner(".check-login-button", false);
                }
            }, () => {
                this.buttonSpinner(".check-login-button", false);
            });
        }
    }
}